import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nResources } from '@domagude/nospen-packages/frontend/ui/i18n';

const supportedLanguages = ['en', 'lt'] as const;
type SupportedLanguage = (typeof supportedLanguages)[number];

const isBrowser = typeof window !== 'undefined';

const getStoredLanguage = (): SupportedLanguage | null => {
  if (!isBrowser) {
    return null;
  }

  try {
    const stored = window.localStorage.getItem('preferredLanguage');
    return supportedLanguages.find((lang) => lang === stored) || null;
  } catch (error) {
    return null;
  }
};

const getDomainDefaultLanguage = (): SupportedLanguage => {
  if (!isBrowser) {
    return 'en';
  }

  const hostname = window.location.hostname.toLowerCase();

  if (hostname === 'nospen.lt' || hostname === 'www.nospen.lt') {
    return 'lt';
  }

  if (hostname === 'nospen.com' || hostname === 'www.nospen.com') {
    return 'en';
  }

  return 'en';
};

const initialLanguage = getStoredLanguage() || getDomainDefaultLanguage();

i18n.use(initReactI18next).init({
  resources: i18nResources,
  lng: initialLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
